namespace Matrix.Data {
    export interface GetCustomDateResponse extends Serenity.ServiceResponse {
        Date?: string;
    }
}
